import { Navigate, Route, Routes } from 'react-router-dom'
import { Col, FloatButton, Layout, Row } from 'antd'
import HomePage from './components/HomePage'
import { useEffect, useState } from 'react'
import {
    BgColorsOutlined
} from '@ant-design/icons';
import ServerSelect from './components/ServerSelect';
import Players from './components/Players';
import Inventory from './components/Inventory';
import HatchHistory from './components/HatchHistory';
function LoggedInArea() {
    const [server, setServer] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkServer();

        async function checkServer() {
            const server = localStorage.getItem('selectedServer');
            if (server) {
                setServer(JSON.parse(server));
            }
            setLoading(false);
        }
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <Routes>
                <Route path="/serverselect" element={<ServerSelect setServer={setServer} />} />
                <Route path="/dashboard" element={server ? <HomePage /> : <Navigate to="/app/serverselect" />} />
                <Route path="/players" element={server ? <Players /> : <Navigate to="/app/serverselect" />} />
                <Route path="/inventory" element={server ? <Inventory /> : <Navigate to="/app/serverselect" />} />
                <Route path="/history" element={server ? <HatchHistory /> : <Navigate to="/app/serverselect" />} />

            </Routes>
        </div>

    )
}

export default LoggedInArea
